import authStateChecker from '@nhl/auth-state-checker';

import * as accountAPI from '../../../utils/accountAPI';

import actionCreators from './actionCreators';

const userLoginStatusResponse = actionCreators.userLoginStatusResponse;

const fetchUserLoggedInStatus = partyKey => async dispatch => {
    dispatch(actionCreators.requestUserLoginStatus(partyKey));

    const isLoggedIn = await authStateChecker.checkAuthState();
    dispatch(userLoginStatusResponse(isLoggedIn, partyKey));
};

const logout = () => async dispatch => {
    try {
        await accountAPI.logout();
        doLogoutCleanup(dispatch);
    } catch (e) {
        doLogoutCleanup(dispatch);
    }
};

const doLogoutCleanup = dispatch => {
    dispatch(actionCreators.logout());
    authStateChecker.logout();
};

export default {
    logout,
    userLoginStatusResponse,
    fetchUserLoggedInStatus
};